import { DateRange } from "../..";
import type { ICreateDefaultEventLogFilters } from "./types";

const createDefaultEventLogFilters = ({
  dateRange,
  severity,
  withComments,
  search = "",
  downloadName,
  uploadName,
  reportRange,
  useDefaultDateRange = true,
  projects,
}: ICreateDefaultEventLogFilters) => {
  // prettier-ignore
  const computedDateRange =
        dateRange?.start && dateRange?.end ? (DateRange.fromString(dateRange.start, dateRange.end)?.toDateRange() ?? { start: null, end: null }) :
        useDefaultDateRange ? DateRange.fromDays(7).toDateRange() :
          { start: null, end: null };
  return {
    search: search || "",
    severity: severity || undefined,
    reportRange:
      reportRange?.start && reportRange?.end
        ? (DateRange.fromString(reportRange.start, reportRange.end)?.toDateRange() ?? { start: null, end: null })
        : {
            start: null,
            end: null,
          },
    dateRange: computedDateRange,
    withComments: withComments,
    downloadName: downloadName || undefined,
    uploadName: uploadName || undefined,
    projects: projects || undefined,
  };
};

export { createDefaultEventLogFilters };
